import { render, staticRenderFns } from "./AllBatchesTable.vue?vue&type=template&id=032c14a5&scoped=true&"
import script from "./AllBatchesTable.vue?vue&type=script&lang=js&"
export * from "./AllBatchesTable.vue?vue&type=script&lang=js&"
import style0 from "./AllBatchesTable.vue?vue&type=style&index=0&id=032c14a5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032c14a5",
  null
  
)

export default component.exports